// Button Icon And Text Phase 1============================================

document.addEventListener("DOMContentLoaded", function () {
  const BUTTON_SELECTOR = ".custom-clear-it-new #AddToCart, .custom-light-up-new-v2-phase1 #AddToCart, .custom-collagen-new #AddToCart";

  function enhanceAddToCartButton() {
    const buttons = document.querySelectorAll(BUTTON_SELECTOR);
    if (!buttons.length) return;

    buttons.forEach(btn => {
      const textWrapper = btn.querySelector(".loader-button__text");
      if (!textWrapper) return;

      // Prevent double injection
      if (textWrapper.querySelector(".atc-main")) return;

      // Get original button text
      const textNode = Array.from(textWrapper.childNodes)
        .find(n => n.nodeType === Node.TEXT_NODE && n.textContent.trim());

      const buttonText = textNode
        ? textNode.textContent.trim()
        : "ADD TO CART";

      textWrapper.innerHTML = `
        <span class="atc-main">
          <span class="atc-icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_715_1834)">
                <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.05964 14 11.75 14Z"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
                  stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_715_1834">
                  <rect width="16" height="16" fill="white"/>
                </clipPath>
              </defs>
            </svg>
          </span>

          <span class="atc-text">Add to Cart</span>
        </span>

        <span class="atc-subtext">
          90 days money back guarantee
        </span>
      `;
    });
  }

  // Initial run
  enhanceAddToCartButton();

  // Observe button changes (variant switching re-renders it)
  const observer = new MutationObserver(() => {
    enhanceAddToCartButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});


// Variants text change
(function () {
  // Only run on the custom page
  if (!document.body.classList.contains('custom-light-up-new-v2-phase1')) return;

  const titleMap = {
    '1 Box': 'Single Box',
    '3 Box': 'Box of Three',
  };

  document.querySelectorAll('.bl__cus_block_option_info_title').forEach(function (el) {
    const trimmed = el.textContent.trim();
    if (titleMap[trimmed]) {
      el.textContent = titleMap[trimmed];
    }
  });
})();

// Variants text change
(function () {
  // Only run on the custom page
  if (!document.body.classList.contains('custom-clear-it-new-v2-phase1')) return;

  const titleMap = {
    '1 Box': 'Single Box',
    '3 Box': 'Box of Three',
  };

  document.querySelectorAll('.bl__cus_block_option_info_title').forEach(function (el) {
    const trimmed = el.textContent.trim();
    if (titleMap[trimmed]) {
      el.textContent = titleMap[trimmed];
    }
  });
})();

// Variants text change
(function () {
  // Only run on the custom page
  if (!document.body.classList.contains('custom-collagen-new-v2-phase1')) return;

  const titleMap = {
    '1 Box': 'Single Box',
    '3 Box': 'Box of Three',
  };

  document.querySelectorAll('.bl__cus_block_option_info_title').forEach(function (el) {
    const trimmed = el.textContent.trim();
    if (titleMap[trimmed]) {
      el.textContent = titleMap[trimmed];
    }
  });
})();

(function () {
  const BTN_SELECTOR = ".custom-light-up-new-v2-phase1 #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


(function () {
  const BTN_SELECTOR = ".custom-light-up-new-v2-phase3 #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();



(function () {
  const BTN_SELECTOR = ".custom-collagen-new-v2-phase1 #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();

(function () {
  const BTN_SELECTOR = ".custom-collagen-new-v2-phase3 #StickyAddToCart";

  function enhanceButton() {
    const btn = document.querySelector(BTN_SELECTOR);
    if (!btn) return;

    // Prevent duplicate injection
    if (btn.querySelector(".js-atc-main")) return;

    const labelText = btn.textContent.trim();
    btn.textContent = "";

    const wrapper = document.createElement("span");
    wrapper.className = "js-atc-main";
    wrapper.style.display = "flex";
    wrapper.style.flexDirection = "column";
    wrapper.style.alignItems = "center";
    wrapper.style.lineHeight = "1.2";
    wrapper.style.gap = "5px";

    // Top row (icon + text)
    const topRow = document.createElement("span");
    topRow.style.display = "inline-flex";
    topRow.style.alignItems = "center";
    topRow.style.gap = "8px";

    topRow.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0)">
          <path d="M11.75 11.5H5.69812C5.46394 11.5 5.23719 11.4177 5.05741 11.2677C4.87764 11.1176 4.75624 10.9092 4.71438 10.6788L3.04562 1.5H1.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M5.75 14C6.44036 14 7 13.4404 7 12.75C7 12.0596 6.44036 11.5 5.75 11.5C5.05964 11.5 4.5 12.0596 4.5 12.75C4.5 13.4404 5.05964 14 5.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M11.75 14C12.4404 14 13 13.4404 13 12.75C13 12.0596 12.4404 11.5 11.75 11.5C11.0596 11.5 10.5 12.0596 10.5 12.75C10.5 13.4404 11.0596 14 11.75 14Z"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.40938 9H12.2563C12.4904 8.99997 12.7172 8.91774 12.897 8.76766C13.0767 8.61758 13.1981 8.40917 13.24 8.17875L14 4H3.5"
            stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="16" height="16" fill="white"/>
          </clipPath>
        </defs>
      </svg>
      <span>${labelText}</span>
    `;

    // Subtext (YOUR LATEST STYLE)
    const subText = document.createElement("span");
    subText.textContent = "90 days money back guarantee";
    subText.style.fontSize = "12px";
    subText.style.fontWeight = "400";

    wrapper.appendChild(topRow);
    wrapper.appendChild(subText);
    btn.appendChild(wrapper);
  }

  // Initial run
  document.addEventListener("DOMContentLoaded", enhanceButton);

  // Observe button changes (variant switch, AJAX re-render)
  const observer = new MutationObserver(() => {
    enhanceButton();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
})();


// Button Icon And Text Phase 3 ============================================
